<br>

<!-- Modal ver detalle-->
<div class="modal fade" id="exampleModal2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modito" class="modal-content">
            <div class="modal-header">
                <p style="font-weight: bold" class="modal-title" id="exampleModalLabel">Descripcion del detalle cod: [{{ codi_detalle_edit }}]</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <p style="font-style: italic; color:gray">Detalle: "{{ det_edit }}"</p>
                <p style="font-weight: bold">Importe: ${{ imp_edit }}</p>
                <p>Fecha_Ticket: {{ fec_edit | date:'dd/MM/yyyy' }}</p>
                <hr>
            </div>
            <div id="fotitomodal" style="text-align: center;">
                <img (click)="fullscreen()" id="fotocopia" style="text-align: center; width: 250px; height: 200px;" src="{{ fotito }}">
                &nbsp;
                &nbsp;
                <br>
                <br>
                <span (click)="rotate()" id="imgbajar">
                    <i id="imgbajar" class="material-icons">
                        repeat
                    </i>
                </span>
                <br>
            </div>
            <div class="modal-footer" style="text-align: center">
                <button style="text-align: center" type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
            </div>
        </div>
    </div>
</div>

<div class="animated fadeIn" id="todo">
    <div class="col-lg-12">

        <app-loading class="m-5" *ngIf="loading"></app-loading>

        <p style="font-weight: bold">
            Gasto COD: [{{ codgas }}] - "{{ detallegasto_edit }}"
        </p>
        <p>
            [{{dataSource.data.length}} registros]
        </p>
        <p>
            Suma Total: $ {{ tot_gasto }}
        </p>
        <hr>
        <!-- Button trigger modal 2 
        <button *ngIf="codi_detalle_edit" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal2">
            ver
        </button>
        -->
        <div id="grid" #TABLE>
            <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar..">
            </mat-form-field>

            <div class="example-container mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                    <!--- Note that these columns can be defined in any order.
                The actual rendered columns are set as a property on the row definition" -->
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Position Column -->
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
                        <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                    </ng-container>

                    <ng-container matColumnDef="COD_DETALLE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> COD_DETALLE </th>
                        <td mat-cell *matCellDef="let element"> {{element.COD_DETALLE}} </td>
                    </ng-container>
                    <ng-container matColumnDef="FECHA_CARGA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA_CARGA </th>
                        <td mat-cell *matCellDef="let element"> {{element.FECHA_CARGA | date:"dd/MM/yy"}} </td>
                    </ng-container>
                    <ng-container matColumnDef="FECHA_TICKET">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA_TICKET </th>
                        <td mat-cell *matCellDef="let element"> {{element.FECHA_TICKET | date:"dd/MM/yy"}} </td>
                    </ng-container>
                    <ng-container matColumnDef="DETALLE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> DETALLE </th>
                        <td style="font-style: italic; font-weight: bold;" mat-cell *matCellDef="let element"> "{{element.DETALLE}}"</td>
                    </ng-container>
                    <ng-container matColumnDef="IMPORTE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> IMPORTE </th>
                        <td style="font-weight: bold;" mat-cell *matCellDef="let element"> ${{element.IMPORTE}} </td>
                    </ng-container>
                    <ng-container matColumnDef="CATEGORIA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> CATEGORIA </th>
                        <td mat-cell *matCellDef="let element"> {{ element.CATEGORIA }} </td>
                    </ng-container>
                    <ng-container matColumnDef="OBSERVACIONES">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> OBSERVACIONES </th>
                        <td mat-cell *matCellDef="let element"> {{ element.OBSERVACIONES }} </td>
                    </ng-container>
                    <ng-container matColumnDef="IMAGEN">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> IMAGEN </th>
                        <td mat-cell *matCellDef="let element"> <img style="width: 50px; height: 50px;" src="{{element.IMAGEN}}"></td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row (click)="selectRow(row.COD_DETALLE,row.DETALLE,row.IMPORTE,row.FECHA_TICKET,row.IMAGEN)" data-toggle="modal" data-target="#exampleModal2" *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
                </table>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>

        </div>
    </div>
    <a type="button" target="_blank" routerLink="/print-gastos" class="btn btn-success btn-block" mat-button (click)="imprimirGastos()" >IMPRIMIR GASTO {{ codgas }}</a>
    <button [disabled]="estadoElegido=='AUTORIZADO'" type="button" class="btn btn-danger btn-block" mat-button (click)="autorizarGasto()" routerLink="/vergastos-pagos">AUTORIZAR</button>
    <button class="btn btn-success btn-block" mat-button (click)="exportAsExcel()" [disabled]="dataSource.data.length==0">Exportar a Excel</button>
    <button type="button" class="btn btn-secondary btn-block" mat-button (click)="volver()" routerLink="/vergastos-pagos">Volver</button>
</div>